<script>
    import { TOKEN_SESSION, USER , TOAST_MESSAGE} from "../../stores";
    import { Datatable, PaginationRowCount, PaginationButtons } from "svelte-simple-datatables";
    import { onMount } from "svelte";
    import * as Fx from '../../globals/Fx.js'
    import { createEventDispatcher } from "svelte";
    import GLOBALS from "../../globals/GLOBALS";
    import ModalRecaudo from './Modal_recaudo.svelte'
    
    
    String.prototype.lines = function() { return this.split(/\r*\n/); }
    String.prototype.lineCount = function() { return this.lines().length; }
    
    const dispatch = createEventDispatcher();
    
    export let periodo
    
    let DATOSTABLA
    let DATOSALL_LIQS
    let link
    let rowSelected = null
    let idSelected = null
    let showSave = false
    let showAllLiqs = false
    let inputValorPagado = 0
    let textAnotaciones = 0
    let showModalRecaudo = false
    let rows

    $:console.log("ScreenListaRecaudos.svelte rowSelected: ",rowSelected, idSelected )
    onMount(() =>{
        _LIQ_QUERY("GETLIQRECAUDOS", {periodo})
    })
    
    const _LIQ_QUERY = async (QUERY, data) => {
        // const data = {};
        const URL = GLOBALS.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/liquidaciones/QUERY/${QUERY}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then(async (json) => {
                if (json.status === 403) TOKEN_SESSION.set(null)
                if (json.result === "success") {
                    switch(QUERY){
                        case "GETLIQRECAUDOS":
                            DATOSTABLA = json.rows
                            TOAST_MESSAGE.set(json)
                        break;
                        case "GETALLLIQS":
                            DATOSALL_LIQS = json.rows
                            TOAST_MESSAGE.set(json)
                        break;
                    }
                }else{
                    switch(QUERY){
                        case "LISTASUSXFUERA":
                        break;
                    }
                    TOAST_MESSAGE.set(json)
                }
    
            }) //print data to console
            .catch((err) => console.log("Request Failed", err)); // Catch errors
    };
    
    
    const _close = () => {
        dispatch("close")
    }
    
    const _showAllLiquidaciones = async () => {
        const res = await _LIQ_QUERY("GETALLLIQS", { contrato_id : idSelected.split("row-")[1]})
        showModalRecaudo = true
    }

    const _closeModalRecaudo = () => {
        showModalRecaudo = false
    }

    const settings = {
            sortable: true,
            rowsPerPage: 1000,
            columnFilter: true,
            labels: {
                search: "Buscar...", // search input placeholer
                filter: "Filtro", // filter inputs placeholder
                noRows: "Registro no encontrado",
                info: "Mostrando {start} a {end} de {rows} registros",
                previous: "Anterior",
                next: "Sguiente",
            },
            blocks: {
                searchInput: false,
                paginationButtons: false,
                paginationRowCount: false,
            }
        };
    
        const _exportExcel = () => {
            let HTML = `<tabla>
                <thead>
                    <th data-key="num">#</th>
                    <th data-key="liq_periodo">Periodo</th>
                    <th data-key="sus_id_contrato">Contrato Id</th>
                    <th data-key="sus_nombre">Nombre</th>
                    <th data-key="sus_nit">NIT</th>
                    <th class="text-end" data-key="liq_cmso_energia">Csmo Energía</th>
                    <th class="text-end" data-key="liq_importe_liquidado">Importe Liquidado</th>
                    <th class="text-end" data-key="liq_valor_pagado">Valor Recaudado</th>
                    <th class="text-end" data-key="liq_saldo">Saldo</th>
                </thead>
                `
            DATOSTABLA.forEach(element => {
                HTML += `<tr>`
                Object.keys(element).forEach((key) => {
                    // HTML += `<td>${element[key]}</td>`
                    if ((`liq_csmo_energia|liq_importe_liquidado|liq_valor_pagado|liq_saldo`).indexOf(key) > -1){
                        HTML += `<td>${Fx.formatter.format(element[key]).cop()}</td>`
                    }else{
                        HTML += `<td>${element[key]}</td>`
                    }
                })
                HTML += `</td>`
            })
            HTML += `</table>`
    
            const data = Fx.fnExcelReport(HTML, "Listado de Consumos Cargados en el Periodo")
            link.setAttribute("href", data.data_type + ', ' + encodeURIComponent(Fx.myUTF8(data.tab_text)));
            link.setAttribute("download", "Lista_recaudos.xls")
            
        }
    
        const _toggleSelect = async (id, row) => {
            if (showSave && idSelected !== id) {
                const opc = confirm("Atención! No has guardado los cambios. ¿Deseas descartarlos?")
                if (opc)
                    await _LIQ_QUERY("GETLIQRECAUDOS", {periodo})
                else 
                    return
                showSave = false
                idSelected = null;
                showAllLiqs = false
            }else{
                idSelected = id;
                rowSelected = row
                showAllLiqs = true
            }
        };
    
        const _changeInput = () => {
            showSave = true
        }
    
        const _saveRecaudo = async  () => {
            showSave = false
            let data = []
            data.push({liq_id_contrato:rowSelected.sus_id_contrato,liq_valor_pagado:inputValorPagado.value})
            await _LIQ_QUERY("SAVERECAUDO",{periodo,data})
            _LIQ_QUERY("GETLIQRECAUDOS", {periodo})
        }
    
        const onKeyPress = e => {
            if (e.charCode === 13 && showSave) {
                _saveRecaudo()
            }
        };
    
        const _saveRecaudoFromModal = async (event) => {
            const { periodo, data } = event.detail
            await _LIQ_QUERY("SAVERECAUDO",{periodo,data})
            await _showAllLiquidaciones()
        }

        const _saveAnotacionesFromModal = async (event) => {
            const { periodo, data } = event.detail
            await _LIQ_QUERY("SAVEANOTACIONES",{periodo,data})
            await _showAllLiquidaciones()
        }
    
    </script>
    
    <div class="datatable-container">
        <ModalRecaudo 
                show={showModalRecaudo} 
                on:close={() => _closeModalRecaudo()} 
                on:saveRecaudo={_saveRecaudoFromModal}
                on:saveAnotaciones={_saveAnotacionesFromModal}
                data={DATOSALL_LIQS}
        />
        <div class="d-flex direction-row justify-content-between">
            <h4>Recaudos en el periodo liquidado</h4>
            <!-- <div class="btn btn-danger align-self-end"  on:click={() => _close()}>Cerrar</div> -->
           
            <div class="d-flex direction-row justify-content-between">
                {#if showAllLiqs}
                    <div title={"Todas las liquidaciones"} class="circular d-flex justify-content-center align-items-center" style="background-color:#673ab7" on:click={() => _showAllLiquidaciones()}>
                        <ion-icon name="document-text"></ion-icon>
                    </div>
                {/if}
                {#if showSave}
                    <div class="circular d-flex justify-content-center align-items-center" style="background-color:tomato" on:click={() => _saveRecaudo()} title={"Confirmar Consumo" }>
                        <ion-icon name="save-sharp"></ion-icon>
                    </div>
                {/if}
                <a class="circular d-flex justify-content-center align-items-center" style="background-color:green"  id="link" bind:this={link} on:click={() => _exportExcel()} title={"Exportar a Excel"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-excel-fill" viewBox="0 0 16 16">
                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM5.884 6.68 8 9.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 10l2.233 2.68a.5.5 0 0 1-.768.64L8 10.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 10 5.116 7.32a.5.5 0 1 1 .768-.64z"/>
                      </svg>
                </a>
                <div title={"Cerrar"} class="circular d-flex justify-content-center align-items-center" on:click={() => _close()}>
                    <ion-icon name="close-outline"></ion-icon>
                </div>
            </div>
        </div>
        {#if DATOSTABLA}
            <Datatable {settings} data={DATOSTABLA} bind:dataRows={rows} id={"tabla-recaudos"}>
                <thead>
                    <tr>
                        <th data-key="num">#</th>
                        <th data-key="liq_periodo">Periodo</th>
                        <th data-key="sus_id_contrato">Contrato Id</th>
                        <th data-key="sus_nombre">Nombre</th>
                        <th data-key="sus_nit">NIT</th>
                        <th class="text-end" data-key="liq_cmso_energia">Csmo Energía</th>
                        <th class="text-end" data-key="liq_importe_liquidado">Importe Liquidado</th>
                        <th class="text-end" data-key="liq_valor_pagado">Valor Recaudado</th>
                        <th class="text-end" data-key="liq_saldo">Saldo</th>
                    </tr>
                </thead>
                <tbody>
                    {#if rows}
                        {#each $rows as row, idx}
                            <tr
                                class="{idx % 2 === 0 ? 'bg-par' : 'bg-impar'}"
                                class:active={`row-${row.sus_id_contrato}` ===  idSelected}
                                on:click={() => _toggleSelect(`row-${row.sus_id_contrato}`, row)}
        
                            >
                                <td class="text-center" col="2">{row.num}</td>
                                <td class="text-center">{row.liq_periodo}</td>
                                <td class="text-center">{row.sus_id_contrato}</td>
                                <td>{row.sus_nombre}</td>
                                <td>{row.sus_nit}</td>
                                <td><div class="text-end" style="width:100%">{Fx.formatter.format(row.liq_csmo_energia).cop()}</div></td>
                                <td><div class="text-end" style="width:100%">{Fx.formatter.format(row.liq_importe_liquidado).cop()}</div></td>
                                <td class="text-end d-flex flex-row" style="color:tomato;background-color:#ff634722">
                                    {#if `row-${row.sus_id_contrato}` !==  idSelected}
                                        <div class="text-end" style="width:100%">{Fx.formatter.format(row.liq_valor_pagado).cop()}</div>
                                    {:else}
                                        <input 
                                            class="inputCsmo" 
                                            type="text" 
                                            bind:this={inputValorPagado}
                                            value={row.liq_valor_pagado} 
                                            on:input={() => _changeInput()}
                                            on:keypress={onKeyPress}
                                        />
                                    {/if}
                                </td>
                                <td><div class="text-end" style="width:100%">{Fx.formatter.format(row.liq_saldo).cop()}</div></td>
                            </tr>
                        {/each}
                    {/if}
                </tbody>
            </Datatable>
        {/if}
    </div>
    <footer>
        <PaginationButtons id={"tabla-recaudos"}/>
        <PaginationRowCount id={"tabla-recaudos"}/>
    </footer>
    
    
    <style>
    
        footer {
            position: fixed;
            display: flex;
            background-color: #fff;
            bottom:0;
            width: 100%;
            padding: 10px;
        }
    
        th {
            min-width: 10em;
            text-align: left;
        }
    
        td {
            text-align: left;
            white-space: nowrap;
            padding: 10px 10px;
        }
    
        tr {
            cursor: pointer;
            color: #3f51b5b5;
            font-size: 0.8em;
            transition: background-color 500ms;
        }
    
        tr:hover {
            background-color:#14518d33;
            color: #2c3e50;
        }
    
        tr.active {
            background-color: #2c3e50 !important;
            color: #fff !important;
        }
    
        .datatable-container {
            height: 76vh;
            max-height: 100vh;
            padding-top: 12px;
            margin-bottom: 40px;
            /* margin: 20px 0; */
        }
    
        .bg-par {
            background-color: #fafcff;
        }
    
        .bg-impar {
            background-color: #f2f6ff;
        }
    
        .circular {
            height: 30px;
            width: 30px;
            border-radius: 50%;
            background-color: #2c3e50;
            color : #fff;
            cursor: pointer;
            transition: all 250ms;
            margin-right: 10px;
        }
    
        .circular:hover {
            transform: scale(1.2);
        }
    
        .inputCsmo {
            border: 0;
            text-align: right;
            background-color: transparent;
            min-width: 1em;
            color:#fff;
        }
    
        input:focus {
            color: #FFF;
        }
    
    </style>